"use strict";

exports.__esModule = true;
exports.default = matcher;
var _extendOwn = _interopRequireDefault(require("./extendOwn.js"));
var _isMatch = _interopRequireDefault(require("./isMatch.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = (0, _extendOwn.default)({}, attrs);
  return function (obj) {
    return (0, _isMatch.default)(obj, attrs);
  };
}